import React from 'react'
import { TypeSectionTabs } from '../../../lib/types'
import { PageSection } from '../../page-section'
import { ContentProps } from '../../renderer'
import { TabContentRenderer } from '../../renderer/tab-content'
import { Tabs } from './Tabs'

export const TabsSection: React.FC<ContentProps<TypeSectionTabs>> = ({ className, structure }) => {
  const {
    sys,
    fields: { internalName, background, itemTab, heading },
  } = structure

  return (
    <PageSection
      internalName={internalName}
      sysStructure={sys}
      className={className}
      background={background}
      heading={heading}
    >
      <Tabs
        labels={itemTab.map(({ fields: { label } }) => label)}
        content={itemTab.map(({ fields: { content } }, i) => (
          <TabContentRenderer structure={content} key={i} />
        ))}
      />
    </PageSection>
  )
}
